import { TextField } from '@fluentui/react';

import { actions, useFormSelector } from '../../../slice';
import { FormVariables } from '../../../slice/newFormReducers';

export default () => {
  const value = useFormSelector(selector);

  return (
    <TextField
      label="Sipariş Notu"
      value={value || ""}
      onChange={onChange}
      multiline
      autoAdjustHeight
    />
  );
};

const selector = (state: FormVariables) => state.note;
const onChange = (_?: any, newValue?: string) =>
  actions.setFormVariable(["note", newValue]);
